import { render, staticRenderFns } from "./SalemanRegister.vue?vue&type=template&id=4586e401&scoped=true&"
import script from "./SalemanRegister.vue?vue&type=script&lang=js&"
export * from "./SalemanRegister.vue?vue&type=script&lang=js&"
import style0 from "./SalemanRegister.vue?vue&type=style&index=0&id=4586e401&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4586e401",
  null
  
)

export default component.exports